import { render } from "./custom-collection-carousels.vue?vue&type=template&id=5400805d"
import script from "./custom-collection-carousels.vue?vue&type=script&lang=js"
export * from "./custom-collection-carousels.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__